import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import FetchSelect from '../../../../core/form/FetchSelect';
import Row from '../../../../core/layout/Row';
import Column from '../../../../core/layout/Column';
import Button from '../../../../core/form/Button';
import RangeDateInput from '../../../../core/form/RangeDateInput';

const UnitRatingsListFilter = (props) => (
  <Row>
    <Column size={2}>
      <FetchSelect
        required
        url="/courses"
        label="Select the course"
        disabled={props.fetching}
        value={get(props.values, 'course')}
        onChange={(value) => props.onChange('course', value)}
        sortCondition={['order']}
        resultTransformer={{
          text: 'name',
          value: 'id',
        }}
      />
    </Column>
    <Column size={4}>
      <RangeDateInput
        required
        label="Period"
        disabled={props.fetching}
        onChange={(dates) => {
          props.onChange('from', dates[0]);
          props.onChange('to', dates[1]);
        }}
        placeholder={['From', 'To']}
        value={[get(props.values, 'from', undefined), get(props.values, 'to', undefined)]}
        errorText={get(props.errors, 'from', '')}
      />
    </Column>
    <Column size={2}>
      <div
        style={{
          height: 42,
        }}
      />
      <Button label="Search" icon="search" onClick={props.onSearch} />
    </Column>
  </Row>
);

UnitRatingsListFilter.propTypes = {
  values: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  fetching: PropTypes.bool,
  onSearch: PropTypes.func.isRequired,
};

UnitRatingsListFilter.defaultProps = {
  fetching: false,
};

export default UnitRatingsListFilter;
